export const FETCH_TASK = "FETCH_TASK";
export const FETCH_TASK_SUCCESS = "FETCH_TASK_SUCCESS";
export const FETCH_TASK_FAILURE = "FETCH_TASK_FAILURE";

export const SAVE_TASK = "SAVE_TASK";
export const SAVE_TASK_SUCCESS = "SAVE_TASK_SUCCESS";
export const SAVE_TASK_FAILURE = "SAVE_TASK_FAILURE";

export const CHANGE_TASK_STATUS = "CHANGE_TASK_STATUS";
export const CHANGE_TASK_STATUS_SUCCESS = "CHANGE_TASK_STATUS_SUCCESS";
export const CHANGE_TASK_STATUS_FAILURE = "CHANGE_TASK_STATUS_FAILURE";

export const FETCH_PROJECT_MODULE = "FETCH_PROJECT_MODULE";
export const FETCH_PROJECT_MODULE_SUCCESS = "FETCH_PROJECT_MODULE_SUCCESS";
export const FETCH_PROJECT_MODULE_FAILURE = "FETCH_PROJECT_MODULE_FAILURE";
export const FETCH_PROJECT_MODULE_CLEAR = "FETCH_PROJECT_MODULE_CLEAR";
  
